import { useState } from 'react';
import './AddInsuranceModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import { auth } from '../../../firebase/firebase-config';
import { useAuthState } from 'react-firebase-hooks/auth';
import { createInsurance, updateInsurance } from "../../../services/facilities";

const override = {
    marginTop: '20px'
};

function AddInsuranceModal({ onClose, onContentAdded, editData = null } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const isEditMode = !!editData;
    const [user] = useAuthState(auth);

    const initialValues = {
        name: editData?.name || ''
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Insurance name is required')
    })

    const handleSubmitData = async (values: any) => {
        try {
            setLoading(true);

            let reqData = {
                ...values
            };

            if(isEditMode) {
                await updateInsurance(editData.id, reqData);
                onContentAdded();
                toast.success('Insurance updated successfully');
            } else {
                await createInsurance(reqData);
                setLoading(false);
                onContentAdded();
                
                toast.success("Insurance created successfully", {
                    pauseOnHover: false,
                    closeOnClick: true,
                });
            }
        } catch (error) {
            console.log('Error: ', error)
            setLoading(false);

            toast.error("Error", {
                pauseOnHover: false,
                closeOnClick: true,
            });
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <div>
            <div className='modal-container student-modal-assignment' id="insurance-modal">
                <div className='modal-head'>
                    <p className="modal-title">Insurance Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                        <BeatLoader
                            color="#3080ED" 
                            loading={loading}
                            cssOverride={override}
                        />
                    </div>
                    <form action="" className="auth-form">
                        {error && <ErrorMessage error={error} visible={true} />}
                        <Form 
                            initialValues={initialValues}
                            onSubmit={handleSubmitData}
                            validationSchema={validationSchema}
                        >
                            <p className="label-text">Insurance Name: </p>
                            <FormField name="name" type="text" placeholder="Enter insurance name"/>

                            <br />
                            <br />
                            {!loading && <Button isOutLined={true} isFullWidth={false} title={isEditMode ? 'UPDATE DATA' : "SUBMIT DATA"}/>}
                        </Form>
                    </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}></div>
        </div>
    );
}

export default AddInsuranceModal;